import { render, staticRenderFns } from "./ComponentBillboard.vue?vue&type=template&id=05cfdd0c&scoped=true"
import script from "./ComponentBillboard.vue?vue&type=script&lang=js"
export * from "./ComponentBillboard.vue?vue&type=script&lang=js"
import style0 from "./ComponentBillboard.vue?vue&type=style&index=0&id=05cfdd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cfdd0c",
  null
  
)

export default component.exports